import type { DecisionEngineDestinationUI } from "./definition";

export const iterableUI: DecisionEngineDestinationUI = {
  campaignSetup: "template",
  resourceName: "campaign",
  channelDescription: "Iterable",
  getReferenceString: (s) => `{{ ${s} }}`,
  getResourceUrl: (campaign) =>
    `https://app.iterable.com/campaigns/${campaign.id}`,
  isInactive: (campaign) =>
    campaign.status === "Ready" || campaign.status === "Finished",
  isPreviewSupported: true,
  getTemplateResourceType: ({ type }) => `${type}-template`,
  getResourceType: () => "campaign",
  getEmailPreviewMethod: "e2e",
  isTestSendSupported: true,
};

export const iterableCampaignUI: DecisionEngineDestinationUI = {
  campaignSetup: "resource",
  resourceName: "campaign",
  channelDescription: "Iterable",
  getReferenceString: (s) => `{{ ${s} }}`,
  getResourceUrl: (campaign) =>
    `https://app.iterable.com/campaigns/${campaign.id}`,
  isInactive: (campaign) =>
    campaign.status === "Ready" || campaign.status === "Finished",
  isPreviewSupported: true,
  getTemplateResourceType: () => "campaign",
  getResourceType: () => "campaign",
  getEmailPreviewMethod: "e2e",
  isTestSendSupported: true,
};
